import { render, staticRenderFns } from "./ModalStack.htm?vue&type=template&id=164a74aa&scoped=true&external"
import script from "./ModalStack.js?vue&type=script&lang=js&external"
export * from "./ModalStack.js?vue&type=script&lang=js&external"
import style0 from "./ModalStack.scss?vue&type=style&index=0&id=164a74aa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a74aa",
  null
  
)

export default component.exports